import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  // Login API returns 'token', not 'accessToken'
  const token = tokenData.token || tokenData.accessToken;
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch admin dashboard data
export const getAdminDashboard = async (filter = {}, options = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/AdminDashboard/get`, filter, {
      headers: getAuthHeader(),
      signal: options.signal,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin dashboard:", error);
    throw error;
  }
};

// API to fetch spa manager finance dashboard data
export const getSpaManagerFinanceDashboard = async (filter = {}, options = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/AdminDashboard/getSpaManagerFinanceDashboard`, filter, {
      headers: getAuthHeader(),
      signal: options.signal,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching spa manager finance dashboard:", error);
    throw error;
  }
};

